import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../../../../services/helpers.service';
import { NotificationService } from '../../../../../services/notification.service';
import { CountriesService } from '../../../../../services/countries.service';
import { Router, ActivatedRoute } from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddMessagingBundleComponent } from '../../../../modals/add-messaging-bundle/add-messaging-bundle.component';
import { MessageService } from 'primeng/api';
import { AppConfig } from '../../../../../app.config';

@Component({
  selector: 'app-messaging-bundle-admin',
  templateUrl: './messaging-bundle-admin.component.html',
  styleUrls: ['./messaging-bundle-admin.component.scss'],
  providers: [MessageService]
})
export class MessagingBundleAdminComponent implements OnInit {
  public bundles : any = [];
  public loading : boolean = false;
  public columns: any = [
    { header: "Description", field: "packageDescription", type: 'string' },
    { header: "Type", field: "typeID", type: 'type' },
    { header: "Credits", field: "credits", type: 'string' },
    { header: "Cost", field: "amount", type: 'currency' },
    { header: "Cost per Message", field: "costPerSMS", type: 'currencyExtra' },
    { header: "Country", field: "country", type: 'country' }
  ];
  public countries : any = [];

  constructor(
    private notificationService : NotificationService,
    private helpersService : HelpersService,
    private confirmationService: ConfirmationService,
    public modalService: NgbModal,
    public messageService : MessageService,
    public router : Router,
    private countriesService : CountriesService,
    private appConfig : AppConfig
  ) {
    //this.countries = this.appConfig.getSupportedCountries();
    this.countriesService.getAllCountries().subscribe(countries=>{
      this.countries = countries.map(x=>{return {...x, label: x.country, value: x.code}});
    });
   }

  ngOnInit() {
    this.getBundles();
  }

  getBundles(){
    this.loading = true;
    this.notificationService.getBundles().subscribe(bundles=>{
      this.loading = false;
      this.bundles = bundles;
    })
  }
  
  addBundle(){
    const modalRef = this.modalService.open(AddMessagingBundleComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal'
    });
    modalRef.result.then(result => {
      this.messageService.add({life: 4000, detail: "Bundle has been added."});
      this.getBundles();
    }, onrejected => {});
  }

  deleteBundle(bundle){
    this.confirmationService.confirm({
      header: 'Remove Bundle',
      message: 'Are you sure that you want remove this bundle?',
      accept: () => {
        this.notificationService.deleteBundle(bundle.id).subscribe(result=>{
          this.getBundles();
        })
      }
    });
  }

  getCountryName(code){
    var country = this.countries.filter(x=>{return x.value===code});
    return country.length>0 ? country[0].label : 'N/A';
  }


}
